var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "box" }, [
        _c(
          "div",
          { staticClass: "left-box" },
          [
            _c("localLifeMobile", {
              attrs: { "table-data": _vm.tableData },
              on: { childData: _vm.handleChildData },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-box" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              _vm._s(_vm.activeNum === 1 ? "搜索定位模块" : "本地生活模块")
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px" } },
            [
              _vm.activeNum != 1
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        "element-loading-text": "加载中...",
                        "element-loading-spinner": "el-icon-loading",
                        "header-cell-style": { "text-align": "center" },
                        "cell-style": { "text-align": "center" },
                        data: _vm.tableData,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { width: "80", type: "index", label: "序号" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { width: "200", prop: "name", label: "名称" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { width: "200", prop: "", label: "上下线状态" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeStatus(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.enable,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "enable", $$v)
                                      },
                                      expression: "scope.row.enable",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3403219137
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", width: "190", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.actNum != 8
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                            icon: "el-icon-edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setting(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("管理")]
                                      )
                                    : _c("div", [_vm._v("-")]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2896924503
                        ),
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        background: "#fff",
                        "border-radius": "10px",
                        padding: "15px",
                      },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { width: "600px" },
                          attrs: { "label-width": "130px" },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "背景图：" } },
                            [
                              _vm.tableData[_vm.activeNum - 1].pic
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "160px",
                                        height: "60px",
                                        position: "relative",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "100%",
                                          display: "block",
                                          height: "100%",
                                        },
                                        attrs: {
                                          src: _vm.tableData[_vm.activeNum - 1]
                                            .pic,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "el-icon-circle-close",
                                        staticStyle: {
                                          position: "absolute",
                                          right: "-18px",
                                          top: "-10px",
                                          "font-size": "18px",
                                          cursor: "pointer",
                                        },
                                        on: { click: _vm.delPic },
                                      }),
                                    ]
                                  )
                                : _c(
                                    "el-upload",
                                    {
                                      ref: "upload",
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action: "",
                                        limit: 1,
                                        "http-request": function (value) {
                                          return _vm.handleFileUpload(value)
                                        },
                                        "show-file-list": false,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "40px" },
                                          attrs: { slot: "trigger" },
                                          slot: "trigger",
                                        },
                                        [_vm._v("+")]
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("div", { staticClass: "tips" }, [
                                _vm._v(
                                  "建议尺寸256*256 PNG图片(商品信息加载前展示)"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "定位文字颜色：" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value:
                                        _vm.tableData[_vm.activeNum - 1]
                                          .textColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tableData[_vm.activeNum - 1],
                                          "textColor",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "tableData[activeNum-1].textColor",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-color-picker", {
                                    model: {
                                      value:
                                        _vm.tableData[_vm.activeNum - 1]
                                          .textColor,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tableData[_vm.activeNum - 1],
                                          "textColor",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "tableData[activeNum-1].textColor",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "搜索框提示文案：" } },
                            [
                              _c("el-input", {
                                model: {
                                  value:
                                    _vm.tableData[_vm.activeNum - 1].searchInfo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.tableData[_vm.activeNum - 1],
                                      "searchInfo",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "tableData[activeNum-1].searchInfo",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {},
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-right": "15px" },
                                  attrs: { plain: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goBack()
                                    },
                                  },
                                },
                                [_vm._v("返回")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.save },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("ModulePopup", { ref: "ModulePopup" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }